import React, { useState, useEffect } from "react";
import { Icon } from "components/SvgIcons";
import CustomCompletedIngredientItems from "./CustomCompletedIngredientItems";
import CustomUncompletedIngredientItems from "./CustomUncompletedIngredientItems";
import CustomIngredientItemInput from "./CustomIngredientItemInput";
import { ItemHead, LeftCol, RecipeTitle, IconWrapper } from "../styled";
import { CustomGroceryContent } from "./styled";
import { CustomDescription } from "./styled";

const CustomGrocery = ({ customItems = [], showCustomInput, customEdit }) => {
  const [isOpen, setOpen] = useState(false);

  const toggleItem = () => {
    setOpen(!isOpen);
  };

  useEffect(() => {
    if (showCustomInput) {
      setOpen(true);
    }
  }, [showCustomInput]);

  const completedItems = customItems.filter((v) => v.check);
  const uncompletedItems = customItems.filter((v) => !v.check);

  return customItems.length > 0 ? (
    <>
      <ItemHead>
        <LeftCol>
          <IconWrapper onClick={toggleItem} isOpen={isOpen}>
            <Icon icon="swipe_next" />
          </IconWrapper>
          <CustomDescription>
            <RecipeTitle>Custom Ingredients</RecipeTitle>
          </CustomDescription>
        </LeftCol>
      </ItemHead>
      {isOpen && (
        <CustomGroceryContent>
          {showCustomInput && <CustomIngredientItemInput customEdit={customEdit} />}
          <CustomUncompletedIngredientItems items={uncompletedItems} />
          <CustomCompletedIngredientItems items={completedItems} />
        </CustomGroceryContent>
      )}
    </>
  ) : showCustomInput ? (
    <CustomIngredientItemInput customEdit={customEdit} />
  ) : null;
};

export default CustomGrocery;
